import React, { useRef, useEffect } from 'react';
import 'client/components/Jquery';
import ImageMontage from './utils/collage';
import './utils/freewall';
import './utils/collage.css';

const MONTAGE_CONTAINER_ID = 'montage';
// 方塊寬高最大比例
const pcWidth = 25;
const pcHeight = 33;
const mbWidth = 45;
const mbHeight = 30;
// 方塊寬高隨機微調
const randSize = true;
// 照片比例相符才會顯示
const mustFit = false;
// 方塊間隔
const brickGutter = 6;
// 預計塞多少方塊（根據螢幕大小不會全塞）
const brickAmount = 20;
// 方塊切換時間（秒）
const brickDuration = 0.1;
// 下次更新延遲
const nextDelay = 8 * 1000;
// 指定預設圖示
const placeholder =
    'https%3A%2F%2Fassets.fevercdn.com%2Fpromotion%2Fimg%2Fugc_image%2FdefaultOrigin.jpeg';
// const imageProxyResizeWidth = 600;
//editor 使用
const isEditor = true;

// const mediaCacheCounts = {
//     first: 0,
//     default: 0
// };

// const currentPlayedCounts = {
//     first: 0,
//     default: 0
// };

// let isFocusOnCurrentTab = true;
// const onVisibilityChangeHandler = () => {
//     if (document.visibilityState === 'visible') {
//         isFocusOnCurrentTab = true;
//     } else {
//         isFocusOnCurrentTab = false;
//     }
// };

function Collage() {
    // useInitMontage(queryPromoUUID);

    // const { uuid: promoUUID, promoIdOfUgcLink: promoId, status: promoStatus } = useSelector(
    //     s => s.promo
    // );
    const imageMontageRef = useRef(null);

    // const initFlow = async () => {
    //     imageMontageRef.current = new ImageMontage(
    //         `#${MONTAGE_CONTAINER_ID}`,
    //         isMobile() ? mbWidth : pcWidth,
    //         isMobile() ? mbHeight : pcHeight,
    //         randSize,
    //         mustFit,
    //         brickGutter,
    //         brickAmount,
    //         brickDuration,
    //         placeholder,
    //         isEditor
    //     );
    //     imageMontageRef.current.initBricks();
    //     playImageMontage({
    //         imageMontageRef
    //     });
    // };

    // initFlow();
    // initial
    useEffect(() => {
        // eslint-disable-next-line no-undef
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const initFlow = async () => {
            imageMontageRef.current = new ImageMontage(
                `#${MONTAGE_CONTAINER_ID}`,
                isMobile() ? mbWidth : pcWidth,
                isMobile() ? mbHeight : pcHeight,
                randSize,
                mustFit,
                brickGutter,
                brickAmount,
                brickDuration,
                placeholder,
                isEditor
            );
            imageMontageRef.current.initBricks();
            playImageMontage({
                imageMontageRef
            });
        };

        initFlow();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="layout">
            <div id={MONTAGE_CONTAINER_ID} className="free-wall"></div>
        </div>
    );
}

async function playImageMontage({ promoUUID, promoId, imageMontageRef }) {
    const getSetTimeoutHadndler = () =>
        setTimeout(
            () => playImageMontage({ promoUUID, promoId, imageMontageRef }),
            getVisibilityBrickCounts() * brickDuration * 1000 + nextDelay
        );
    const data = fakeData();
    const displayData = [...data.first, ...data.default];
    // const formattedDisplayData = displayData.map(({ value, type }) => ({
    //     type,
    //     value: convertProxyImgUrl({
    //         url: value,
    //         resizeWidth: imageProxyResizeWidth
    //     })
    // }));

    const formattedDisplayData = displayData.map(({ value, type }) => ({
        type,
        value
    }));

    imageMontageRef.current.displayImages(formattedDisplayData);
    return getSetTimeoutHadndler();
}

function isMobile() {
    var check = false;
    (function (a) {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                a
            ) ||
            // eslint-disable-next-line no-useless-escape
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
        )
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

function getVisibilityBrickCounts() {
    const allBricks = document.querySelectorAll(`#${MONTAGE_CONTAINER_ID} .brick`);

    let counts = 0;
    let element = null;

    for (element of allBricks) {
        Number(element.style.opacity) !== 0 && counts++;
    }

    return counts;
}

export default Collage;

const fakeData = () => {
    let data = {
        first: [],
        default: []
    };
    const fakeData1 = {
        serialNo: 19945,
        type: 'image',
        value: 'https://assets.fevercdn.com/promotion/img/ugc_image/defaultSquare.png'
    };
    const fakeData2 = {
        serialNo: 19948,
        type: 'image',
        value: 'https://assets.fevercdn.com/promotion/img/ugc_image/defaultOrigin.jpeg'
    };

    for (let i = 0; i < 4; i++) {
        data.default.push(fakeData1);
        data.default.push(fakeData2);
    }
    return data;
};
